import { FC, useCallback, useState } from "react";
import { LayoutConst, useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { API, Endpoints } from "@brg/api";
import { BrgButton, ButtonVariant, useBreakpoint, useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { RectangularButtonFilled } from "../../components/buttons";
import {
    ImportModalBody,
    CloseModalIconWrapper,
    ImportModalHeaderRow,
    ImportModalTitle,
    ImportModalDescription,
    ImportModalError,
    ImportModalErrorInputBlock,
    ImportInputRow,
    ImportModalInput,
    Divider,
} from "./styles";
import { BottomGroup } from "../TransferProjectModal/styles";

export const ImportProjectModal: FC = () => {
    const modal = useModal();
    const toasts = useToasts();
    const { t } = useTranslation();
    const is744 = useBreakpoint(LayoutConst.screen.s)
    const [code, setCode] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    const isCodeFormatValid = useCallback((value: string) => /^[A-Z0-9]+-[A-Z0-9]+$/i.test(value), []);

    const onSubmit = useCallback(() => {
        const trimmed = code?.trim() ?? "";
        if (!trimmed) {
            setError(t("import_project_modal.error_empty"));
            return;
        }
        if (!isCodeFormatValid(trimmed)) {
            setError(t("import_project_modal.error_invalid"));
            return;
        }
        setError(null);
        setIsSubmitting(true);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url("/api/DataTransfer/ImportProject")
            .post()
            .addQuery("dataTransferId", trimmed)
            .send()
            .then((r: Response) => (r?.ok ? Promise.resolve() : Promise.reject()))
            .then(() => {
                modal.hide();
                modal.show("import-project-success");
            })
            .catch(() => {
                setError(t("import_project_modal.error_invalid"));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }, [code, isCodeFormatValid, modal, t]);

    const isConfirmDisabled = isSubmitting || !code?.trim();

    return (
        <ImportModalBody>
            <ImportModalHeaderRow>
                <ImportModalTitle>{t("import_project_modal.title")}</ImportModalTitle>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </ImportModalHeaderRow>
            <ImportModalDescription>{t("import_project_modal.description_1")}</ImportModalDescription>
            <ImportModalDescription>{t("import_project_modal.description_2")}</ImportModalDescription>
            <Divider />
            <BottomGroup>
                <ImportModalDescription>{t("import_project_modal.description_3")}</ImportModalDescription>
                <ImportModalErrorInputBlock>
                    {error && <ImportModalError>{error}</ImportModalError>}
                    <ImportInputRow>
                        <ImportModalInput
                            type="text"
                            value={code}
                            onChange={(e) => {
                                setCode(e.target.value);
                                setError(null);
                            }}
                            placeholder={t("import_project_modal.placeholder")}
                            disabled={isSubmitting}
                        />
                        <BrgButton
                            variant={ButtonVariant.Filled}
                            disabled={isConfirmDisabled}
                            onClick={onSubmit}
                            width={207}
                            fullWidth={is744}
                        >
                            {t("import_project_modal.confirm")}
                        </BrgButton>
                    </ImportInputRow>
                </ImportModalErrorInputBlock>
            </BottomGroup>
        </ImportModalBody>
    );
};
import { FC, useCallback, useState } from "react";
import { LayoutConst, useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { API, Endpoints } from "@brg/api";
import { BrgButton, ButtonVariant, useBreakpoint, useToasts } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { RectangularButtonFilled } from "../../components/buttons";
import {
    ImportModalBody,
    CloseModalIconWrapper,
    ImportModalHeaderRow,
    ImportModalTitle,
    ImportModalDescription,
    ImportModalError,
    ImportModalErrorInputBlock,
    ImportInputRow,
    ImportModalInput,
    Divider,
} from "./styles";
import { BottomGroup } from "../TransferProjectModal/styles";

export const ImportProjectModal: FC = () => {
    const modal = useModal();
    const toasts = useToasts();
    const { t } = useTranslation();
    const is744 = useBreakpoint(LayoutConst.screen.s)
    const [code, setCode] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    const isCodeFormatValid = useCallback((value: string) => /^[A-Z0-9]+-[A-Z0-9]+$/i.test(value), []);

    const onSubmit = useCallback(() => {
        const trimmed = code?.trim() ?? "";
        if (!trimmed) {
            setError(t("import_project_modal.error_empty"));
            return;
        }
        if (!isCodeFormatValid(trimmed)) {
            setError(t("import_project_modal.error_invalid"));
            return;
        }
        setError(null);
        setIsSubmitting(true);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url("/api/DataTransfer/ImportProject")
            .post()
            .addQuery("dataTransferId", trimmed)
            .send()
            .then((r: Response) => (r?.ok ? Promise.resolve() : Promise.reject()))
            .then(() => {
                modal.hide();
                modal.show("import-project-success");
            })
            .catch(() => {
                setError(t("import_project_modal.error_invalid"));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }, [code, isCodeFormatValid, modal, t]);

    const isConfirmDisabled = isSubmitting || !code?.trim();

    return (
        <ImportModalBody>
            <ImportModalHeaderRow>
                <ImportModalTitle>{t("import_project_modal.title")}</ImportModalTitle>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </ImportModalHeaderRow>
            <ImportModalDescription>{t("import_project_modal.description_1")}</ImportModalDescription>
            <ImportModalDescription>{t("import_project_modal.description_2")}</ImportModalDescription>
            <Divider />
            <BottomGroup>
                <ImportModalDescription>{t("import_project_modal.description_3")}</ImportModalDescription>
                <ImportModalErrorInputBlock>
                    {error && <ImportModalError>{error}</ImportModalError>}
                    <ImportInputRow>
                        <ImportModalInput
                            type="text"
                            value={code}
                            onChange={(e) => {
                                setCode(e.target.value);
                                setError(null);
                            }}
                            placeholder={t("import_project_modal.placeholder")}
                            disabled={isSubmitting}
                        />
                        <BrgButton
                            variant={ButtonVariant.Filled}
                            disabled={isConfirmDisabled}
                            onClick={onSubmit}
                            width={207}
                            fullWidth={is744}
                        >
                            {t("import_project_modal.confirm")}
                        </BrgButton>
                    </ImportInputRow>
                </ImportModalErrorInputBlock>
            </BottomGroup>
        </ImportModalBody>
    );
};
